const appReducer = (state, action) => {
  const { type, ...data } = action;

  switch (type) {
    case 'employee_data': {
      return {...state, employee_data : {...state.employee_data, ...data}}
    }
    case 'toggle dragger click': {
      return { ...state, employee_data : { ...state.employee_data, click_dragger: !state.employee_data.click_dragger} };
    }
    default:
      return { ...state, ...data };
  }
};

export default appReducer;
